module.exports = __webpack_public_path__ + "img/course_img.96894a7d.png";